<ng-container *ngIf="!isActiveLsCode">
  <div class="flexbox-column gap-0 h-100 overflow-hidden" appSpin [spinnerConfig]="spinnerConfig()">
    <form class="search-block px-2 w-100" (click)="$event.stopPropagation()" (keydown.tab)="$event.stopPropagation()" (keydown.shift.tab)="$event.stopPropagation()">
        <mat-form-field class="fixed-label w-100 icon-field-before mb-2 w-100 pt-2" floatLabel="always">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search" maxlength="20" #searchField [(ngModel)]="lsSearchTerm"
            [ngModelOptions]="{standalone: true}" (keyup)="handleLsSearch($event.target.value)" autocomplete="off">
          <span matPrefix>
            <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
          </span>
        </mat-form-field>
    </form>

    <div class="flexbox-column gap-0 map-tabs w-100 flex-1 overflow-hidden"(click)="$event.stopPropagation()" (keydown.tab)="$event.stopPropagation()"
    (keydown.shift.tab)="$event.stopPropagation()">
      <button mat-button mat-flat-button color="primary" class="button-medium add-new-button" style="right: 8px;"
        (click)="createLs();$event.stopPropagation()">
        <div class="flexbox-row gap-8">
            <i class="fa-solid fa-plus"></i>
            <span class="button-label">New</span>
        </div>
      </button>

      <mat-tab-group class="ls-tab-grup button-group-tabs is-tabs-group flex-1 overflow-hidden" [selectedIndex]="lsTabIndex">
        <mat-tab class="ls-all">
          <ng-template mat-tab-label class="all-label">
            <span title="All" (click)="changeLsTab(ALL)">All</span>
          </ng-template>
          <div class="flex-table fixed-header w-100 h-100 overflow-auto" *ngIf="allLs && allLs.length > 0; else noAllLs">
            <div class="flex-table-header">
              <div class="ft-row">
                <p class="ft-header-cell col-done-icon ps-2"></p>
                <p class="ft-header-cell col-leadsheetcode">LS Code</p>
                <p class="ft-header-cell col-leadsheetname flex-1 overflow-hidden">Name</p>
                <p class="ft-cell col-action pe-2"></p>
              </div>
            </div>
            <ng-container *ngFor="let als of allLs; trackBy: trackByAllLeadsheets;">
              <div class="ft-row hover-action" (click)="confirmSaveLeadsheet(parentObject, als, moveType);">
                <p class="ft-cell col-done-icon ps-2">
                    <i class="fa-regular fa-check text-success" *ngIf="als.leadsheetid === TbLeadSheetId || als.leadsheetid === leadSheetId"></i>
                </p>
                <p class="ft-cell col-leadsheetcode">
                  <span class="ellipse" title="{{als.leadsheetcode}}">
                    {{als.leadsheetcode}}
                  </span>
                </p>
                <p class="ft-cell col-leadsheetname flex-1 overflow-hidden">
                  <span class="ellipse" title="{{als.leadsheetname}}">
                    {{als.leadsheetname}}
                  </span>
                </p>
                <p class="ft-cell col-action pe-2">
                  <ng-container *ngIf="als.ismastersource === 0">
                    <button mat-button class="button-smaller-icon hover-action-item kebab-button" [matMenuTriggerFor]="alsMenu" #closeAlsMenu="matMenuTrigger" (click)="$event.stopPropagation();lsObject = als;">
                        <i class="fas fa-ellipsis-vertical"></i>
                    </button>
                  </ng-container>
                </p>
              </div>
            </ng-container>
          </div>
          <ng-template #noAllLs>
            <div class="no-data-found">
              <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
              <h6>No records found!</h6>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab class="newly-added">
          <ng-template mat-tab-label class="new-label">
            <span title="Newly Added" (click)="changeLsTab(NEW)">
              Newly Added
            </span>
          </ng-template>
          <div class="flex-table fixed-header w-100 h-100 overflow-auto" *ngIf="newLs && newLs.length > 0; else noNewLs">
            <div class="flex-table-header">
              <div class="ft-row">
                <p class="ft-header-cell col-done-icon ps-2"></p>
                <p class="ft-header-cell col-leadsheetcode">LS Code</p>
                <p class="ft-header-cell col-leadsheetname flex-1 overflow-hidden">Description</p>
                <p class="ft-cell col-action pe-2"></p>
              </div>
            </div>
            <ng-container *ngFor="let nls of newLs; trackBy: trackByNewLeadsheets;">
              <div class="ft-row hover-action" (click)="confirmSaveLeadsheet(parentObject, nls, moveType);">
                <p class="ft-cell col-done-icon ps-2">
                    <i class="fa-regular fa-check text-success" *ngIf="nls.leadsheetid === TbLeadSheetId || nls.leadsheetid === leadSheetId"></i>
                </p>
                <p class="ft-cell col-leadsheetcode">
                  <span class="ellipse" title="{{nls.leadsheetcode}}">
                    {{nls.leadsheetcode}}
                  </span>
                </p>
                <p class="ft-cell col-leadsheetname flex-1 overflow-hidden">
                  <span class="ellipse" title="{{nls.leadsheetname}}">
                    {{nls.leadsheetname}}
                  </span>
                </p>
                <p class="ft-cell col-action pe-2">
                  <ng-container *ngIf="nls.ismastersource === 0">
                    <button mat-button class="button-smaller-icon hover-action-item kebab-button" [matMenuTriggerFor]="nlsMenu" #closeNlsMenu="matMenuTrigger" (click)="$event.stopPropagation();lsObject=nls;">
                        <i class="fas fa-ellipsis-vertical"></i>
                    </button>
                  </ng-container>
                </p>
              </div>
            </ng-container>
          </div>

          <ng-template #noNewLs>
            <div class="no-data-found">
              <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
              <h6>No records found!</h6>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isActiveLsCode">
  <div class="flexbox-column h-100 p-3" (click)="$event.stopPropagation()" (keydown.tab)="$event.stopPropagation()" (keydown.shift.tab)="$event.stopPropagation()" appSpin [spinnerConfig]="spinnerConfig()">
    <div class="title-block flexbox-row gap-8">
      <button mat-button *ngIf="!isEditLeadSheetCode" class="button-text" (click)="backToLsCode('ADD')">
        <i class="fa-regular fa-arrow-left"></i>
      </button>
      <button mat-button *ngIf="isEditLeadSheetCode" class="button-text" (click)="backToLsCode('EDIT')">
        <i class="fa-regular fa-arrow-left"></i>
      </button>
      <h6 class="title">
        {{isEditLeadSheetCode?'Edit Leadsheet':'Add New Leadsheet'}}
      </h6>
    </div>


    <ng-container class="text" *ngIf="isShowLsError">
      <div class="no-data-found">
        <i class="fa-regular fa-triangle-exclamation text-warning fa-6x"></i>
        <h6>You haven't saved the details below!</h6>
      </div>
    </ng-container>

    <span class="text" *ngIf="addLeadSheetForm.get('lsName').errors?.maxlength"> </span>
    <form class="flexbox-column" autoComplete="off" [formGroup]="addLeadSheetForm">
      <div class="ng-form-field required w-100">
        <label>Group</label>
        <ng-select (keydown.arrowdown)="$event.stopPropagation()" (keydown.arrowup)="$event.stopPropagation()"
          [items]="groups" labelForId="groups" bindLabel="fingroupname" bindValue="fingroupid"
          [virtualScroll]="true" [selectOnTab]="true" [clearable]="false" formControlName="group"
          placeholder="Select" (change)="getSubGroups();onChangeGroup($event)" title="{{groupTitle}}"
          [ngClass]="{'ls-edit-disable': isEditLeadSheetCode}" required>
          <ng-template ng-option-tmp let-item="item">
            <div title="{{item.fingroupname}}">{{item.fingroupname}}</div>
          </ng-template>
        </ng-select>
      </div>
      <div class="ng-form-field required w-100">
        <label>Sub Group</label>
        <ng-select (keydown.arrowdown)="$event.stopPropagation()" (keydown.arrowup)="$event.stopPropagation()"
          [items]="subGroups" labelForId="subGroups" bindLabel="finsubgroupname" bindValue="finsubgroupid"
          [selectOnTab]="true" [virtualScroll]="true" [clearable]="false" formControlName="subGroup" placeholder=""
          (change)="getLeadSheetNextCode();onChangeSubGroup($event)" title="{{subgroupTitle}}"
          [ngClass]="{'ls-edit-disable': isEditLeadSheetCode}" required>
          <ng-template ng-option-tmp let-item="item">
            <span title="{{item.finsubgroupname}}">{{item.finsubgroupname}}</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="ng-form-field w-100 required">
        <label>Available Leadsheet Code</label>
        <ng-select (keydown.arrowdown)="$event.stopPropagation()" (keydown.arrowup)="$event.stopPropagation()"
          [items]="leadSheetNextCode" bindLabel="leadsheetcode" bindValue="leadsheetcode" [selectOnTab]="true"
          [virtualScroll]="true" [clearable]="false" formControlName="lsCode" placeholder=""
          [ngClass]="{'ls-edit-disable': isEditLeadSheetCode}" (change)="onChangelsCode($event)"
          title="{{lsCodeTitle}}" required>
          <ng-template ng-option-tmp let-item="item">
            <span title="{{item.leadsheetcode}}">{{item.leadsheetcode}}</span>
          </ng-template>
        </ng-select>
      </div>
      <mat-form-field class="fixed-label w-100 required" floatLabel="always">
        <mat-label>Lead Sheet Name</mat-label>
        <input matInput formControlName="lsName" placeholder="Lead Sheet Name" maxlength="100" (keydown.enter)="$event.preventDefault()">
      </mat-form-field>

      <input type="hidden" formControlName="leadSheetId">
      <div class="button-group w-100">
        <button mat-button mat-stroked-button color="dark" class="button-medium flex-1" (click)="cancelLsCode()">
          Cancel </button>

        <button mat-button mat-flat-button color="primary" class="button-medium flex-1"
          [ngClass]="{'disable-button': !addLeadSheetForm.valid}" [disabled]="!addLeadSheetForm.valid"
          (click)="saveNewLeadSheetCode()" *ngIf="!isEditLeadSheetCode"> Add </button>
        <button mat-button mat-flat-button color="primary" class="button-medium flex-1"
          [ngClass]="{'disable-button': !addLeadSheetForm.valid}" [disabled]="!addLeadSheetForm.valid"
          (click)="updateLeadSheetCode()" *ngIf="isEditLeadSheetCode"> Save </button>
      </div>
    </form>

  </div>
</ng-container>

<mat-menu #alsMenu="matMenu" xPosition="before" (click)="$event.stopPropagation()">
  <button mat-menu-item (click)="$event.stopPropagation();editLeadSheetCode()" class="mat-menu-item">
    <span class="flexbox-row gap-8">
      <i class="fa-regular fa-pen fs-15"></i>
      <span class="button-label">Edit</span>
    </span>
  </button>
  <button mat-menu-item (click)="$event.stopPropagation();deleteLsDialog('all')" class="mat-menu-item">
    <span class="flexbox-row gap-8">
        <i class="fa-regular fa-trash-can"></i>
        <span class="button-label">Delete</span>
    </span>
  </button>
</mat-menu>

<mat-menu #nlsMenu="matMenu" xPosition="before" (click)="$event.stopPropagation()">
  <button mat-menu-item (click)="$event.stopPropagation();editLeadSheetCode()" class="mat-menu-item">
    <span class="flexbox-row gap-8">
      <i class="fa-regular fa-pen fs-15"></i>
      <span class="button-label">Edit</span>
    </span>
  </button>
  <button mat-menu-item (click)="$event.stopPropagation();deleteLsDialog('new')" class="mat-menu-item">
    <span class="flexbox-row gap-8">
        <i class="fa-regular fa-trash-can"></i>
        <span class="button-label">Delete</span>
    </span>
  </button>
</mat-menu>
